import * as React from "react";

let SelectMenu = (props) => {
    const options = props.lista.map(option => {
        return (
            <option value={option.value}> {option.label}</option>
        )
    })
    return (
        <select {...props} >
            {options}
        </select>
    )
}

export default SelectMenu;